import { FiMail, FiPhone, FiMapPin, FiLinkedin, FiGithub } from 'react-icons/fi';

export const contactInfo = {
  name: 'Pedro Riccio',
  title: 'Engenheiro de Software | Desenvolvedor Backend',
  email: 'pedroworkdev@gmail.com',
  phone: '+55 (75) 9 9804-2767',
  location: 'Brasil',
  description: 'Engenheiro de Software especializado em desenvolvimento backend, com experiência em cibersegurança e gestão técnica. Sempre aberto a novos desafios e projetos interessantes!'
};

export const contactMethods = [
  {
    id: 1,
    icon: <FiMail />,
    title: 'Email',
    value: 'pedroworkdev@gmail.com',
    link: 'mailto:pedroworkdev@gmail.com',
    description: 'Respondo em até 24 horas'
  },
  {
    id: 2,
    icon: <FiPhone />,
    title: 'WhatsApp',
    value: '+55 (75) 9 9804-2767',
    link: 'https://wa.me/5575998042767',
    description: 'WhatsApp disponível'
  },
  {
    id: 3,
    icon: <FiMapPin />,
    title: 'Localização',
    value: 'Bahia, BR',
    link: '#',
    description: 'Disponível para remoto'
  }
];

export const socialLinks = [
  {
    id: 1,
    name: 'LinkedIn',
    icon: <FiLinkedin />,
    url: 'https://www.linkedin.com/in/pedro-riccio/',
    color: '#0077B5'
  },
  {
    id: 2,
    name: 'GitHub',
    icon: <FiGithub />,
    url: 'https://github.com/IIBladeII',
    color: '#333'
  }
];